var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_451_295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78121 5.00004H1.09371C0.490608 5.00004 0 4.50943 0 3.90621V1.09371C0 0.490608 0.490608 0 1.09371 0H5.78121C6.38443 0 6.87504 0.490608 6.87504 1.09371V3.90621C6.87504 4.50943 6.38443 5.00004 5.78121 5.00004ZM1.09371 0.9375C1.00754 0.9375 0.9375 1.00754 0.9375 1.09371V3.90621C0.9375 3.9925 1.00754 4.06254 1.09371 4.06254H5.78121C5.8675 4.06254 5.93754 3.9925 5.93754 3.90621V1.09371C5.93754 1.00754 5.8675 0.9375 5.78121 0.9375H1.09371Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78121 15H1.09371C0.490608 15 0 14.5094 0 13.9063V7.3438C0 6.74058 0.490608 6.24997 1.09371 6.24997H5.78121C6.38443 6.24997 6.87504 6.74058 6.87504 7.3438V13.9063C6.87504 14.5094 6.38443 15 5.78121 15ZM1.09371 7.18747C1.00754 7.18747 0.9375 7.25751 0.9375 7.3438V13.9063C0.9375 13.9925 1.00754 14.0625 1.09371 14.0625H5.78121C5.8675 14.0625 5.93754 13.9925 5.93754 13.9063V7.3438C5.93754 7.25751 5.8675 7.18747 5.78121 7.18747H1.09371Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9063 15H9.21883C8.61561 15 8.125 14.5094 8.125 13.9063V11.0938C8.125 10.4906 8.61561 9.99997 9.21883 9.99997H13.9063C14.5094 9.99997 15 10.4906 15 11.0938V13.9063C15 14.5094 14.5094 15 13.9063 15ZM9.21883 10.9375C9.13254 10.9375 9.0625 11.0075 9.0625 11.0938V13.9063C9.0625 13.9925 9.13254 14.0625 9.21883 14.0625H13.9063C13.9925 14.0625 14.0625 13.9925 14.0625 13.9063V11.0938C14.0625 11.0075 13.9925 10.9375 13.9063 10.9375H9.21883Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9063 8.75004H9.21883C8.61561 8.75004 8.125 8.25943 8.125 7.65621V1.09371C8.125 0.490608 8.61561 0 9.21883 0H13.9063C14.5094 0 15 0.490608 15 1.09371V7.65621C15 8.25943 14.5094 8.75004 13.9063 8.75004ZM9.21883 0.9375C9.13254 0.9375 9.0625 1.00754 9.0625 1.09371V7.65621C9.0625 7.7425 9.13254 7.81254 9.21883 7.81254H13.9063C13.9925 7.81254 14.0625 7.7425 14.0625 7.65621V1.09371C14.0625 1.00754 13.9925 0.9375 13.9063 0.9375H9.21883Z",
    fill: "#353535"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_451_295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInactiveIcon);
export default __webpack_public_path__ + "static/media/dashboard-inactive-icon.8f0a74434f41939ac24e3517529e1a8e.svg";
export { ForwardRef as ReactComponent };